import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GetReceiptEffect } from './get-receipt.effect';
import { getReceiptReducer } from './get-receipt.reducer';
import { GET_RECEIPT_STORE_NAME, GetReceiptState } from './get-receipt.state';

/** Token of the GetReceipt reducer */
export const GET_RECEIPT_REDUCER_TOKEN = new InjectionToken<ActionReducer<GetReceiptState, Action>>(
  'Feature GetReceipt Reducer'
);

/** Provide default reducer for GetReceipt store */
export function getDefaultGetReceiptReducer() {
  return getReceiptReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(GET_RECEIPT_STORE_NAME, GET_RECEIPT_REDUCER_TOKEN),
    EffectsModule.forFeature([GetReceiptEffect]),
  ],
  providers: [{ provide: GET_RECEIPT_REDUCER_TOKEN, useFactory: getDefaultGetReceiptReducer }],
})
export class GetReceiptStoreModule {
  public static forRoot<T extends GetReceiptState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<GetReceiptStoreModule> {
    return {
      ngModule: GetReceiptStoreModule,
      providers: [{ provide: GET_RECEIPT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
